export default {
	pageName: "CompanyDirectory",

	spacing: 10,
	labelsWidth: 30,
	defaultColumnWidth: 200,

	queryWaitTime: 300,
};
